export default __webpack_public_path__ + "static/media/k8.72b25eb8.jpg";